import styled from "styled-components";


export const ModalGrayNotification = styled.div`
  width: 100%;
  background: #F3F4F5;
  padding: 12px 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
`


export const RowGap5 = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`

